import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "col-md-2 add-btn",
  style: {"text-align":"right"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "bi bi-dash fs-3 pe-0" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "bi bi-plus fs-3 pe-0" }, null, -1)
const _hoisted_4 = {
  key: 3,
  class: "discount-hr"
}
const _hoisted_5 = {
  key: 4,
  class: "col-md-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Input = _resolveComponent("Input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode(_component_el_form, {
      model: _ctx.actionForm,
      ref: "actionFromRef"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.actionForm, (form, index) => {
          return (_openBlock(), _createBlock("div", {
            class: _ctx.discount_type == 'SUBSCRIPTION_DISCOUNT' ? 'row' : '',
            key: index
          }, [
            _createVNode("div", {
              class: _ctx.discount_type == 'SUBSCRIPTION_DISCOUNT' ? 'col-md-6' : 'col-md-12'
            }, [
              _createVNode(_component_Select, {
                name: "discount_type",
                target: "discount_type",
                label: _ctx.$t('message.DISCOUNT_TYPE'),
                clearable: true,
                callEmit: true,
                discount_type: _ctx.actionForm[index].discount_type,
                "onUpdate:discount_type": ($event: any) => (_ctx.actionForm[index].discount_type = $event),
                selectData: _ctx.discount_options,
                value: _ctx.actionForm[index].discount_type,
                onChange: ($event: any) => (_ctx.changeDiscountTypeHandler(_ctx.actionForm[index].discount_type))
              }, null, 8, ["label", "discount_type", "onUpdate:discount_type", "selectData", "value", "onChange"]),
              _withDirectives(_createVNode("span", { class: "customer-error" }, _toDisplayString(`${_ctx.$t('message.THIS_FIELD')} ${_ctx.$t('message.IS_REQUIRED')}`), 513), [
                [_vShow, _ctx.actionForm[index].discount_type == '']
              ])
            ], 2),
            (_ctx.actionForm[index].discount_type == 'AMOUNT' || _ctx.actionForm[index].discount_type == 'PERCENT')
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: _ctx.discount_type == 'SUBSCRIPTION_DISCOUNT' ? 'col-md-6' : 'col-md-12'
                }, [
                  _createVNode(_component_Input, {
                    type: "number",
                    name: "discount_amount",
                    label: _ctx.actionForm[index].discount_type == 'AMOUNT' ? _ctx.$t('message.AMOUNT') : _ctx.$t('message.PERCENTAGE'),
                    discount_amount: _ctx.actionForm[index].discount_amount,
                    "onUpdate:discount_amount": ($event: any) => (_ctx.actionForm[index].discount_amount = $event),
                    target: "discount_amount",
                    value: _ctx.actionForm[index].discount_amount
                  }, null, 8, ["label", "discount_amount", "onUpdate:discount_amount", "value"]),
                  _withDirectives(_createVNode("span", { class: "customer-error" }, _toDisplayString(`${_ctx.$t('message.THIS_FIELD')} ${_ctx.$t('message.IS_REQUIRED')}`), 513), [
                    [_vShow, _ctx.actionForm[index].discount_amount == '']
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.actionForm[index].discount_type == 'PRODUCT' || _ctx.discount_type == 'SUBSCRIPTION_DISCOUNT')
              ? (_openBlock(), _createBlock("div", {
                  key: 1,
                  class: _ctx.discount_type == 'SUBSCRIPTION_DISCOUNT' ? 'col-md-10' : 'col-md-12'
                }, [
                  _createVNode(_component_Select, {
                    name: "product_id",
                    target: "product_id",
                    label: 'Products',
                    clearable: true,
                    callEmit: true,
                    product_id: _ctx.actionForm[index].product_id,
                    "onUpdate:product_id": ($event: any) => (_ctx.actionForm[index].product_id = $event),
                    selectData: _ctx.products,
                    value: _ctx.actionForm[index].product_id,
                    filterable: true
                  }, null, 8, ["product_id", "onUpdate:product_id", "selectData", "value"]),
                  _withDirectives(_createVNode("span", { class: "customer-error" }, _toDisplayString(`${_ctx.$t('message.THIS_FIELD')} ${_ctx.$t('message.IS_REQUIRED')}`), 513), [
                    [_vShow, _ctx.actionForm[index].product_id == '']
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.discount_type == 'SUBSCRIPTION_DISCOUNT')
              ? (_openBlock(), _createBlock("div", _hoisted_1, [
                  (index != 0)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        type: "button",
                        class: "router-link-active router-link-exact-active btn btn-sm discount-button discount-remove-button",
                        onClick: ($event: any) => (_ctx.removeProductDiscount(index))
                      }, [
                        _hoisted_2
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (index == _ctx.actionForm.length - 1)
                    ? (_openBlock(), _createBlock("button", {
                        key: 1,
                        type: "button",
                        class: "router-link-active router-link-exact-active btn btn-sm discount-button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addProductDiscount()))
                      }, [
                        _hoisted_3
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.discount_type == 'SUBSCRIPTION_DISCOUNT' && index != _ctx.actionForm.length - 1)
              ? (_openBlock(), _createBlock("hr", _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.discount_type == 'ORDER_DISCOUNT')
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode(_component_Select, {
                    name: "applies_to",
                    target: "applies_to",
                    label: _ctx.$t('message.DISCOUNT_APPLIES_TO'),
                    applies_to: _ctx.actionForm[index].applies_to,
                    "onUpdate:applies_to": ($event: any) => (_ctx.actionForm[index].applies_to = $event),
                    selectData: _ctx.applies_to_options,
                    value: _ctx.actionForm[index].applies_to
                  }, null, 8, ["label", "applies_to", "onUpdate:applies_to", "selectData", "value"])
                ]))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]),
      _: 1
    }, 8, ["model"])
  ], 64))
}